/* AISEN — Calculadora de porta frigorífica (TPC-M). Web Component vanilla, sem React.
   Lógica espelha o módulo fonte C:\dev-env\aisen-calculadoras (calcular/config).
   Markup e labels vêm do Liquid; aqui só comportamento. */
(() => {
  const CFG = {
    secaoCaboLabel: '5,5 × 7,5',
    margemCurvas: 1.07,
    terminalFrioPorPonta: 1.0,
    passo: 0.5,
    folga: 0.1, // vão→marco por lado
    tensaoPadrao: 220,
    pedidoMin: 500,
    canaletaMin: { largura: 8, profundidade: 6 },
    // temp → W/m (primeiro cujo tempMin <= temp). TPC-M só 30/40/50: ≥0→30; -1..-9→40; ≤-10→50.
    tabela: [[0, 30], [-9, 40], [-Infinity, 50]],
    lim: { lMin: 0.7, lMax: 4.5, aMin: 1.9, aMax: 4.5, tempDesn: 15, iMax: 10 },
  };

  const round = (x, dp) => { const f = 10 ** dp; return Math.round(x * f) / f; };
  const brl = (n) => n.toLocaleString('pt-BR');

  function calcular(e) {
    if (!(e.largura > 0) || !(e.altura > 0)) throw new Error('Largura e altura devem ser maiores que zero.');
    if (![127, 220, 380].includes(e.tensao)) throw new Error('Tensão inválida.');

    const alertas = [];
    let larguraMarco = e.largura, alturaMarco = e.altura;
    if (e.referencia === 'vao') { larguraMarco += 2 * CFG.folga; alturaMarco += CFG.folga; }

    const aquecerSoleira = e.soleira == null ? e.temp < 0 : e.soleira;
    const lados = aquecerSoleira ? 4 : 3;
    const P = aquecerSoleira ? 2 * (larguraMarco + alturaMarco) : 2 * alturaMarco + larguraMarco;

    const aquecido = P * CFG.margemCurvas;
    const total = Math.ceil((aquecido + 2 * CFG.terminalFrioPorPonta) / CFG.passo) * CFG.passo;
    const degrau = CFG.tabela.find(([t]) => e.temp >= t)[1];
    const potencia = degrau * aquecido;

    const r = {
      modelo: 'TPC-M', secaoCabo: CFG.secaoCaboLabel,
      larguraMarco: round(larguraMarco, 2), alturaMarco: round(alturaMarco, 2),
      lados, comprimentoTotal: round(total, 1), degrau, potencia: round(potencia, 1),
      pedidoEspecial: e.tensao !== CFG.tensaoPadrao, encaixe: 'nao_informado', alertas,
    };

    if (e.tensao === CFG.tensaoPadrao) {
      r.resistencia = round((220 * 220) / potencia, 1);
      r.corrente = round(potencia / 220, 2);
    } else {
      alertas.push(`Fabricamos em ${e.tensao} V somente sob encomenda, para pedidos a partir de ${CFG.pedidoMin} metros. Fale com nosso comercial.`);
    }

    const cl = e.canaletaL, cp = e.canaletaP, min = CFG.canaletaMin;
    if (cl != null || cp != null) {
      const apertado = (cl != null && cl < min.largura) || (cp != null && cp < min.profundidade);
      if (apertado) {
        r.encaixe = 'apertado';
        alertas.push(`A canaleta informada (${cp ?? '—'} × ${cl ?? '—'} mm) é menor que o recomendado para o TPC-M (mín. ${min.profundidade} × ${min.largura} mm). O cabo pode ser fixado externamente no rebaixo do marco com fita de alumínio — fale com nosso suporte técnico.`);
      } else r.encaixe = 'ok';
    } else {
      alertas.push(`O TPC-M tem seção de ${CFG.secaoCaboLabel} mm. Verifique se a canaleta do seu marco tem ao menos ${min.profundidade} × ${min.largura} mm.`);
    }

    const L = CFG.lim;
    if (larguraMarco < L.lMin || larguraMarco > L.lMax || alturaMarco < L.aMin || alturaMarco > L.aMax)
      alertas.push('Medidas fora do usual para marco de porta frigorífica — confirme as medidas.');
    if (e.temp >= L.tempDesn) alertas.push('Para esta temperatura o aquecimento de batente geralmente é desnecessário.');
    if (r.corrente != null && r.corrente > L.iMax) alertas.push('Corrente elevada — recomendamos dividir em 2 circuitos.');
    if (e.temp < 0 && !aquecerSoleira) alertas.push('Em câmaras congeladas a soleira sem aquecimento tende a formar gelo na base da porta.');

    return r;
  }

  const numBR = (el) => {
    if (!el) return null;
    const v = String(el.value ?? '').trim().replace(',', '.');
    if (v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };

  class AisenPortaCalc extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      const on = { signal: this.ac.signal };
      this.out = this.querySelector('[data-result]');
      this.productUrl = this.getAttribute('data-product-url') || '';
      const fields = ['largura', 'altura', 'temp', 'tensao', 'referencia', 'soleira', 'canaleta_l', 'canaleta_p'];
      this.f = {};
      fields.forEach((k) => { this.f[k] = this.querySelector(`[data-field="${k}"]`); });
      const rerun = () => this.run();
      Object.values(this.f).forEach((el) => {
        if (!el) return;
        el.addEventListener('input', rerun, on);
        el.addEventListener('change', rerun, on);
      });
      const btn = this.querySelector('[data-calc-submit]');
      if (btn) btn.addEventListener('click', (ev) => { ev.preventDefault(); this.run(); }, on);
      this.run();
    }
    disconnectedCallback() { this.ac?.abort(); }

    run() {
      if (!this.out) return;
      const largura = numBR(this.f.largura), altura = numBR(this.f.altura), temp = numBR(this.f.temp);
      const tensao = this.f.tensao ? Number(this.f.tensao.value) : 220; // fabricação padrão
      if (largura == null || altura == null || temp == null || !tensao) {
        this.out.hidden = true;
        return;
      }
      const soleiraVal = this.f.soleira?.value || 'auto';
      const e = {
        largura, altura, temp, tensao,
        referencia: this.f.referencia?.value || 'marco',
        soleira: soleiraVal === 'auto' ? null : soleiraVal === 'sim',
        canaletaL: numBR(this.f.canaleta_l),
        canaletaP: numBR(this.f.canaleta_p),
      };
      let r;
      try { r = calcular(e); } catch (err) {
        this.out.hidden = false;
        this.out.innerHTML = `<p class="aisen-pc__err">${err.message}</p>`;
        return;
      }
      this.render(r);
    }

    render(r) {
      const eletrica = r.pedidoEspecial
        ? `<div class="aisen-pc__special">Fabricação padrão é 220 V. Para <strong>${this.f.tensao.value} V</strong>, o fornecimento é sob encomenda (pedidos a partir de ${CFG.pedidoMin} m). Fale com o comercial.</div>`
        : `<div class="aisen-pc__kpi"><span>Resistência total</span><strong>${brl(r.resistencia)} Ω</strong></div>
           <div class="aisen-pc__kpi"><span>Corrente</span><strong>${brl(r.corrente)} A</strong></div>`;

      const alertas = r.alertas.length
        ? `<ul class="aisen-pc__alerts">${r.alertas.map((a) => `<li>${a}</li>`).join('')}</ul>` : '';

      const encaixe = { ok: '✓ Encaixe OK', apertado: '⚠ Canaleta apertada', nao_informado: 'Canaleta não informada' }[r.encaixe];

      const cta = this.productUrl
        ? `<a class="aisen-pc__cta" href="${this.productUrl}">Comprar cabo TPC-M ${r.degrau} W/m</a>` : '';

      this.out.hidden = false;
      this.out.innerHTML = `
        <div class="aisen-pc__headline">
          <span class="aisen-pc__eyebrow">Você precisa de aproximadamente</span>
          <strong class="aisen-pc__big">${brl(r.comprimentoTotal)} m</strong>
          <span class="aisen-pc__sub">de cabo TPC-M ${r.degrau} W/m · seção ${r.secaoCabo} mm</span>
        </div>
        <div class="aisen-pc__grid">
          <div class="aisen-pc__kpi"><span>Potência do cabo</span><strong>${r.degrau} W/m</strong></div>
          <div class="aisen-pc__kpi"><span>Potência total</span><strong>${brl(r.potencia)} W</strong></div>
          <div class="aisen-pc__kpi"><span>Consumo aprox.</span><strong>${brl(round(r.potencia / 1000 * (Number(this.getAttribute('data-consumo-horas')) || 12), 1))} kWh/dia</strong></div>
          ${eletrica}
          <div class="aisen-pc__kpi"><span>Lados aquecidos</span><strong>${r.lados} lados</strong></div>
          <div class="aisen-pc__kpi"><span>Marco usado</span><strong>${brl(r.larguraMarco)} × ${brl(r.alturaMarco)} m</strong></div>
          <div class="aisen-pc__kpi"><span>Encaixe</span><strong>${encaixe}</strong></div>
        </div>
        ${alertas}
        ${cta}
        <p class="aisen-pc__disc">Estimativa orientativa. A configuração definitiva é confirmada pela equipe técnica AISEN conforme a aplicação.</p>`;
    }
  }

  if (!customElements.get('aisen-porta-calc')) customElements.define('aisen-porta-calc', AisenPortaCalc);
})();
